export const TheadEntryFormAsociatedPass = [
  { name: 'item', order: 'null' },
  { name: 'Código producto', order: 'null' },
  { name: 'Unidad comercial', order: 'null' },
  { name: 'Subpartida arancelaria', order: 'null' },
  { name: 'Unidad de medida', order: 'null' },
  { name: 'Descripción producto', order: 'null' },
  { name: 'Descripción de la mercancía', order: 'null' }
]
